import { msg } from "@lingui/core/macro";
import {
  useAdmittedPatientsWithSignInStatus,
  usePatientInformationFields,
  informationFieldConfigValueSchema,
} from "@/api/Patients";
import { PatientsTableContainer } from "./PatientsTableContainer";
import { useMemo } from "react";
import { getPatientFullName } from "@medoma/models/patients";
import { filterByNameTerms } from "@medoma/components/SearchField/searchUtils";
import { usePatientNameFilter } from "../PatientsContext";

export const AdmittedPatients = () => {
  const { value: filter } = usePatientNameFilter();
  const {
    data: patients,
    isPending,
    isError,
    error,
  } = useAdmittedPatientsWithSignInStatus({});
  const { data: conditionalInformationFields } = usePatientInformationFields();

  const filteredPatients = useMemo(() => {
    if (!filter || !patients) {
      return patients;
    }

    return patients.filter((patient) =>
      filterByNameTerms(getPatientFullName(patient.name), filter),
    );
  }, [patients, filter]);

  const noResultsMessage =
    filteredPatients && patients && filteredPatients.length < patients.length
      ? msg`Det finns inga inskrivna patienter som matchar sökningen`
      : msg`Det finns inga inskrivna patienter`;

  const showPlannedDischarge =
    conditionalInformationFields?.PlannedDischargeDateTime !==
    informationFieldConfigValueSchema.enum.hidden;

  return (
    <PatientsTableContainer
      patients={filteredPatients}
      isPending={isPending}
      isError={isError}
      error={error}
      additionalColumns={
        showPlannedDischarge
          ? ["admittedAt", "plannedDischargeDateTime"]
          : ["admittedAt"]
      }
      showPatientSignInStatus={true}
      showNotifications={true}
      showPatientStatus={true}
      showPrimaryResponsible={true}
      showPlaceOfAssessment={false}
      showPostDischargeProcessed={false}
      loadingMessage={msg`Hämtar inskrivna patienter`}
      errorMessage={msg`Kunde inte hämta inskrivna patienter`}
      noResultsMessage={noResultsMessage}
    />
  );
};
